// Whether a checkout is priced on the Website v2 channel
// (services/pricing/serviceFeeChannels.ts in the API: 60p on gen-2026q4).
//
// The site declares itself two ways: its links into the hosted booking site
// carry `?src=websitev2` (with `return=`, the page to come back to), and its
// own pages can carry `<meta name="baluu-source" content="websitev2">`.
//
// Not priced as its own channel yet (Renato, 2026-09-29): the channel's
// buyer fee isn't on the pricing page, so a checkout that starts on a v2
// site is priced as the surface that renders it: the booking components'
// in-page (0p), the hosted booking site's on a hosted page. Both markers are
// still written (the URL a purchase records keeps `src=websitev2`), they
// just don't change the price. When the pricing page describes the channel,
// flip this to true and add the meta tag back in apps/website's layout.
// This is the one switch: every checkout source detector (packages/ui's
// getSourceInfo, the hosted site's apps/widget libs/getOriginalUrl.js) asks
// it.
export const WEBSITE_V2_CHANNEL_PRICED = false;

/** True when this page is a Website v2 checkout surface AND that channel is
 *  priced as its own. `search` is the page's query string. */
export function isWebsiteV2Checkout(
  search: string,
  doc: Pick<Document, "querySelector"> | null = typeof document === "undefined" ? null : document,
  priced: boolean = WEBSITE_V2_CHANNEL_PRICED,
): boolean {
  if (!priced) return false;
  if (new URLSearchParams(search).get("src") === "websitev2") return true;
  return doc?.querySelector('meta[name="baluu-source"]')?.getAttribute("content") === "websitev2";
}
